import { apiClientWithRefreshToken } from "@/api/apiClient";
import { Pagination, Mobilization } from "@/v2/types";

export default async function FindAllMobilization({
    limit,
    skip,
    search,
    filter,
    raw_where_condition_query,
}: {
    skip?: number;
    limit?: number;
    search?: string;
    filter?: Record<string, any>;
    raw_where_condition_query?: string;
}): Promise<{ data: Mobilization[]; pagination: Pagination }> {
    const res = await apiClientWithRefreshToken({
        url: "/mobilizations",
        method: "GET",
        params: {
            skip: skip ?? 0,
            limit: limit ?? 10,
            ...(raw_where_condition_query && { raw_where_condition_query }),
            ...(search && { search }),
            ...filter,
        },
    });

    return res.data;
}
